import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AdminFeedback from "../components/AdminFeedback";
import API_URL from "../apiConfig";

import "../CSS/admin.css";


function AdminPage() {

    const navigate = useNavigate();


    // ==================================================
    // LOGIN / SESSION
    // ==================================================

    const token =
        localStorage.getItem("token");

    const [username, setUsername] =
        useState(
            localStorage.getItem("username") || ""
        );

    const [authChecked, setAuthChecked] =
        useState(false);

    const [isAuthenticated, setIsAuthenticated] =
        useState(false);


    // ==================================================
    // ADMINBEREICH
    // ==================================================

    const [activeSection, setActiveSection] =
        useState("termine");


    // ==================================================
    // TERMINE
    // ==================================================

    const [appointments, setAppointments] =
        useState([]);

    const [datum, setDatum] =
        useState("");

    const [tag, setTag] =
        useState("");

    const [startzeit, setStartzeit] =
        useState("");

    const [endzeit, setEndzeit] =
        useState("");

    const [status, setStatus] =
        useState("Frei");

    const [editId, setEditId] =
        useState(null);


    // ==================================================
    // NEWS
    // ==================================================

    const [news, setNews] =
        useState([]);

    const [newsTitel, setNewsTitel] =
        useState("");

    const [newsDatum, setNewsDatum] =
        useState(
            getTodayForInput()
        );

    const [newsKurztext, setNewsKurztext] =
        useState("");

    const [newsText, setNewsText] =
        useState("");

    const [newsBild, setNewsBild] =
        useState("");

    const [newsLinkText, setNewsLinkText] =
        useState("");

    const [newsLinkZiel, setNewsLinkZiel] =
        useState("");

    const [newsEditId, setNewsEditId] =
        useState(null);


    // ==================================================
    // LINKS
    // ==================================================

    const [links, setLinks] =
        useState([]);

    const [linkName, setLinkName] =
        useState("");

    const [linkBeschreibung, setLinkBeschreibung] =
        useState("");

    const [linkBild, setLinkBild] =
        useState("");

    const [linkUrl, setLinkUrl] =
        useState("");

    const [linkAktiv, setLinkAktiv] =
        useState(true);

    const [linkReihenfolge, setLinkReihenfolge] =
        useState(1);

    const [linkEditId, setLinkEditId] =
        useState(null);


    // ==================================================
    // SESSION PRÜFEN
    // ==================================================

    useEffect(() => {

        let cancelled = false;


        async function checkAuthentication() {

            try {

                const response =
                    await fetch(
                        `${API_URL}/auth-check.php`,
                        {
                            method: "GET",

                            credentials:
                                "include",

                            headers: {
                                "Accept":
                                    "application/json"
                            }
                        }
                    );


                if (!response.ok) {

                    throw new Error(
                        "Keine gültige Anmeldung."
                    );
                }


                const data =
                    await response.json();


                if (!data.authenticated) {

                    throw new Error(
                        "Keine gültige Anmeldung."
                    );
                }


                if (cancelled) {
                    return;
                }


                if (data.username) {

                    setUsername(
                        data.username
                    );

                    localStorage.setItem(
                        "username",
                        data.username
                    );
                }


                setIsAuthenticated(
                    true
                );

            } catch (error) {

                if (cancelled) {
                    return;
                }


                localStorage.removeItem(
                    "token"
                );

                localStorage.removeItem(
                    "username"
                );


                setIsAuthenticated(
                    false
                );


                navigate(
                    "/login",
                    {
                        replace: true
                    }
                );

            } finally {

                if (!cancelled) {

                    setAuthChecked(
                        true
                    );
                }
            }
        }


        checkAuthentication();


        return () => {

            cancelled = true;
        };

    }, [navigate]);


    // ==================================================
    // DATEN NACH ANMELDUNG LADEN
    // ==================================================

    useEffect(() => {

        if (!isAuthenticated) {
            return;
        }


        loadAppointments();

        loadNews();

        loadLinks();

    }, [isAuthenticated]);  


    // ==================================================
    // BILDPFAD FÜR NEWS
    // ==================================================

    function getNewsImagePath(
        imageValue
    ) {

        if (!imageValue) {
            return "";
        }


        if (
            imageValue.startsWith("/")
        ) {

            return imageValue;
        }


        if (
            imageValue.startsWith(
                "http://"
            ) ||
            imageValue.startsWith(
                "https://"
            )
        ) {

            return imageValue;
        }


        return `/Fotos/news/${imageValue}`;
    }


    // ==================================================
    // BILDPFAD FÜR LINKS
    // ==================================================

    function getLinkImagePath(
        imageValue
    ) {

        if (!imageValue) {
            return "";
        }


        if (
            imageValue.startsWith("/")
        ) {

            return imageValue;
        }


        if (
            imageValue.startsWith(
                "http://"
            ) ||
            imageValue.startsWith(
                "https://"
            )
        ) {

            return imageValue;
        }


        return `/Fotos/${imageValue}`;
    }


    // ==================================================
    // BACKEND-ANTWORT PRÜFEN
    // ==================================================

    async function checkResponse(
        response
    ) {

        let data = {};


        try {

            data =
                await response.json();

        } catch {

            data = {};
        }


        if (
            response.status === 401 ||
            response.status === 403
        ) {

            localStorage.removeItem(
                "token"
            );

            localStorage.removeItem(
                "username"
            );


            setIsAuthenticated(
                false
            );


            navigate(
                "/login",
                {
                    replace: true
                }
            );


            throw new Error(
                "Anmeldung ist abgelaufen."
            );
        }


        if (!response.ok) {

            throw new Error(
                data.error ||
                "Es ist ein Fehler aufgetreten."
            );
        }


        return data;
    }


    // ==================================================
    // DATUM:
    // 2026-08-30 -> 30.08.2026
    // ==================================================

    function formatDateForDatabase(
        dateValue
    ) {

        if (!dateValue) {
            return "";
        }


        const parts =
            dateValue.split("-");


        if (parts.length !== 3) {
            return dateValue;
        }


        const year =
            parts[0];

        const month =
            parts[1];

        const day =
            parts[2];


        return `${day}.${month}.${year}`;
    }


    // ==================================================
    // DATUM:
    // 30.08.2026 -> 2026-08-30
    // ==================================================

    function formatDateForInput(
        dateValue
    ) {

        if (!dateValue) {
            return "";
        }


        const parts =
            dateValue.split(".");


        if (parts.length !== 3) {
            return dateValue;
        }


        const day =
            parts[0];

        const month =
            parts[1];

        const year =
            parts[2];


        return `${year}-${month}-${day}`;
    }


    // ==================================================
    // HEUTIGES DATUM
    // ==================================================

    function getTodayForInput() {

        const today =
            new Date();


        const year =
            today.getFullYear();


        const month =
            String(
                today.getMonth() + 1
            ).padStart(
                2,
                "0"
            );


        const day =
            String(
                today.getDate()
            ).padStart(
                2,
                "0"
            );


        return `${year}-${month}-${day}`;
    }


    // ==================================================
    // WOCHENTAG BERECHNEN
    // ==================================================

    function calculateWeekday(
        dateValue
    ) {

        if (!dateValue) {
            return "";
        }


        const parts =
            dateValue.split("-");


        if (parts.length !== 3) {
            return "";
        }


        const year =
            Number(
                parts[0]
            );

        const month =
            Number(
                parts[1]
            );

        const day =
            Number(
                parts[2]
            );


        const date =
            new Date(
                year,
                month - 1,
                day
            );


        const weekdays = [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
        ];


        return weekdays[
            date.getDay()
        ];
    }


    // ==================================================
    // DATUM GEÄNDERT
    // ==================================================

    function handleDateChange(
        event
    ) {

        const selectedDate =
            event.target.value;


        setDatum(
            selectedDate
        );


        setTag(
            calculateWeekday(
                selectedDate
            )
        );
    }


    // ==================================================
    // ZEIT ZUSAMMENSETZEN
    // ==================================================

    function createTimeString() {

        if (
            !startzeit ||
            !endzeit
        ) {

            return "";
        }


        return `${startzeit} – ${endzeit}`;
    }


    // ==================================================
    // ZEIT ZERLEGEN
    // ==================================================

    function splitTimeString(
        timeValue
    ) {

        if (!timeValue) {

            return {
                start: "",
                end: ""
            };
        }


        const parts =
            timeValue.split(
                /\s*[–-]\s*/
            );


        if (parts.length !== 2) {

            return {
                start: "",
                end: ""
            };
        }


        return {
            start:
                parts[0].trim(),

            end:
                parts[1].trim()
        };
    }


    // ==================================================
    // TERMINE LADEN
    // ==================================================

    function loadAppointments() {

        fetch(
            `${API_URL}/appointments.php`
        )

            .then(
                (response) => {

                    if (!response.ok) {

                        throw new Error(
                            "Termine konnten nicht geladen werden."
                        );
                    }


                    return response.json();
                }
            )

            .then(
                (data) => {

                    setAppointments(
                        data
                    );
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Laden der Termine:",
                        error
                    );
                }
            );
    }


    // ==================================================
    // NEWS LADEN
    // ==================================================

    function loadNews() {

        fetch(
            `${API_URL}/news.php`,
            {
                method:
                    "GET",

                credentials:
                    "include"
            }
        )

            .then(
                (response) => {

                    if (!response.ok) {

                        throw new Error(
                            "News konnten nicht geladen werden."
                        );
                    }


                    return response.json();
                }
            )

            .then(
                (data) => {

                    setNews(
                        data
                    );
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Laden der News:",
                        error
                    );
                }
            );
    }


    // ==================================================
    // LINKS LADEN
    // ==================================================

    function loadLinks() {

        fetch(
            `${API_URL}/links.php`,
            {
                method:
                    "GET",

                credentials:
                    "include"
            }
        )

            .then(
                (response) => {

                    if (!response.ok) {

                        throw new Error(
                            "Links konnten nicht geladen werden."
                        );
                    }


                    return response.json();
                }
            )

            .then(
                (data) => {

                    setLinks(
                        data
);
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Laden der Links:",
                        error
                    );
                }
            );
    }


    // ==================================================
    // TERMIN SPEICHERN / ÄNDERN
    // ==================================================

    function handleAppointmentSubmit(
        event
    ) {

        event.preventDefault();


        if (
            endzeit <= startzeit
        ) {

            alert(
                "Die Endzeit muss nach der Startzeit liegen."
            );

            return;
        }


        const appointment = {

            datum:
                formatDateForDatabase(
                    datum
                ),

            tag:
                tag,

            zeit:
                createTimeString(),

            status:
                status
        };


        const url =
            editId === null

                ? `${API_URL}/appointments.php`

                : `${API_URL}/appointments.php?id=${editId}`;


        const method =
            editId === null
                ? "POST"
                : "PUT";


        fetch(
            url,
            {
                method:
                    method,

                credentials:
                    "include",

                headers: {

                    "Content-Type":
                        "application/json",

                    "Authorization":
                        `Bearer ${token}`
                },

                body:
                    JSON.stringify(
                        appointment
                    )
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    resetAppointmentForm();

                    loadAppointments();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Speichern des Termins:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // TERMIN BEARBEITEN
    // ==================================================

    function handleAppointmentEdit(
        appointment
    ) {

        const times =
            splitTimeString(
                appointment.zeit
            );


        setEditId(
            appointment.id
        );

        setDatum(
            formatDateForInput(
                appointment.datum
            )
        );

        setTag(
            appointment.tag
        );

        setStartzeit(
            times.start
        );

        setEndzeit(
            times.end
        );

        setStatus(
            appointment.status
        );


        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }


    // ==================================================
    // TERMIN LÖSCHEN
    // ==================================================

    function handleAppointmentDelete(
        id
    ) {

        const confirmed =
            window.confirm(
                "Möchtest Du diesen Termin wirklich löschen?"
            );


        if (!confirmed) {
            return;
        }


        fetch(
            `${API_URL}/appointments.php?id=${id}`,
            {
                method:
                    "DELETE",

                credentials:
                    "include",

                headers: {

                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    if (
                        editId === id
                    ) {

                        resetAppointmentForm();
                    }


                    loadAppointments();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Löschen:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // TERMINFORMULAR LEEREN
    // ==================================================

    function resetAppointmentForm() {

        setEditId(
            null
        );

        setDatum(
            ""
        );

        setTag(
            ""
        );

        setStartzeit(
            ""
        );

        setEndzeit(
            ""
        );

        setStatus(
            "Frei"
        );
    }


    // ==================================================
    // NEWS SPEICHERN / ÄNDERN
    // ==================================================

    function handleNewsSubmit(
        event
    ) {

        event.preventDefault();


        if (
            (
                newsLinkText &&
                !newsLinkZiel
            ) ||
            (
                !newsLinkText &&
                newsLinkZiel
            )
        ) {

            alert(
                "Bitte beim News-Link sowohl den Link-Text als auch das Link-Ziel ausfüllen."
            );

            return;
        }


        const newsArticle = {

            titel:
                newsTitel,

            datum:
                formatDateForDatabase(
                    newsDatum
                ),

            kurztext:
                newsKurztext,

            text:
                newsText,

            bild:
                newsBild.trim(),

            link_text:
                newsLinkText.trim(),

            link_ziel:
                newsLinkZiel.trim()
        };


        const url =
            newsEditId === null

                ? `${API_URL}/news.php`

                : `${API_URL}/news.php?id=${newsEditId}`;


        const method =
            newsEditId === null
                ? "POST"
                : "PUT";


        fetch(
            url,
            {
                method:
                    method,

                credentials:
                    "include",

                headers: {

                    "Content-Type":
                        "application/json",

                    "Authorization":
                        `Bearer ${token}`
                },

                body:
                    JSON.stringify(
                        newsArticle
                    )
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    resetNewsForm();

                    loadNews();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Speichern der News:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // NEWS BEARBEITEN
    // ==================================================

    function handleNewsEdit(
        article
    ) {

        setNewsEditId(
            article.id
        );

        setNewsTitel(
            article.titel
        );

        setNewsDatum(
            formatDateForInput(
                article.datum
            )
        );

        setNewsKurztext(
            article.kurztext
        );

        setNewsText(
            article.text
        );

        setNewsBild(
            article.bild || ""
        );

        setNewsLinkText(
            article.link_text || ""
        );

        setNewsLinkZiel(
            article.link_ziel || ""
        );


        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }


    // ==================================================
    // NEWS LÖSCHEN
    // ==================================================

    function handleNewsDelete(
        id
    ) {

        const confirmed =
            window.confirm(
                "Möchtest Du diesen News-Beitrag wirklich löschen?"
            );


        if (!confirmed) {
            return;
        }


        fetch(
            `${API_URL}/news.php?id=${id}`,
            {
                method:
                    "DELETE",

                credentials:
                    "include",

                headers: {

                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    if (
                        newsEditId === id
                    ) {

                        resetNewsForm();
                    }


                    loadNews();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Löschen der News:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // NEWSFORMULAR LEEREN
    // ==================================================

    function resetNewsForm() {

        setNewsEditId(
            null
        );

        setNewsTitel(
            ""
        );

        setNewsDatum(
            getTodayForInput()
        );

        setNewsKurztext(
            ""
        );

        setNewsText(
            ""
        );

        setNewsBild(
            ""
        );

        setNewsLinkText(
            ""
        );

        setNewsLinkZiel(
            ""
        );
    }


    // ==================================================
    // LINK SPEICHERN / ÄNDERN
    // ==================================================

    function handleLinkSubmit(
        event
    ) {

        event.preventDefault();


        const link = {

            name:
                linkName.trim(),

            beschreibung:
                linkBeschreibung.trim(),

            bild:
                linkBild.trim(),

            url:
                linkUrl.trim(),

            aktiv:
                linkAktiv
                    ? 1
                    : 0,

            reihenfolge:
                Number(linkReihenfolge)
        };


        const url =
            linkEditId === null

                ? `${API_URL}/links.php`

                : `${API_URL}/links.php?id=${linkEditId}`;


        const method =
            linkEditId === null
                ? "POST"
                : "PUT";


        fetch(
            url,
            {
                method:
                    method,

                credentials:
                    "include",

                headers: {

                    "Content-Type":
                        "application/json",

                    "Authorization":
                        `Bearer ${token}`
                },

                body:
                    JSON.stringify(
                        link
                    )
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    resetLinkForm();

                    loadLinks();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Speichern des Links:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // LINK BEARBEITEN
    // ==================================================

    function handleLinkEdit(
        link
    ) {

        setLinkEditId(
            link.id
        );

        setLinkName(
            link.name || ""
        );

        setLinkBeschreibung(
            link.beschreibung || ""
        );

        setLinkBild(
            link.bild || ""
        );

        setLinkUrl(
            link.url || ""
        );

        setLinkAktiv(
            Number(
                link.aktiv
            ) === 1
        );

        setLinkReihenfolge(
            Number(link.reihenfolge) || 1
        );


        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }


    // ==================================================
    // LINK LÖSCHEN
    // ==================================================

    function handleLinkDelete(
        id
    ) {

        const confirmed =
            window.confirm(
                "Möchtest Du diesen Link wirklich löschen?"
            );


        if (!confirmed) {
            return;
        }


        fetch(
            `${API_URL}/links.php?id=${id}`,
            {
                method:
                    "DELETE",

                credentials:
                    "include",

                headers: {

                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(
                checkResponse
            )

            .then(
                () => {

                    if (
                        linkEditId === id
                    ) {

                        resetLinkForm();
                    }


                    loadLinks();
                }
            )

            .catch(
                (error) => {

                    console.error(
                        "Fehler beim Löschen des Links:",
                        error
                    );

                    alert(
                        error.message
                    );
                }
            );
    }


    // ==================================================
    // LINKFORMULAR LEEREN
    // ==================================================

    function resetLinkForm() {

        setLinkEditId(
            null
        );

        setLinkName(
            ""
        );

        setLinkBeschreibung(
            ""
        );

        setLinkBild(
            ""
        );

        setLinkUrl(
            ""
        );

        setLinkAktiv(
            true
        );

        const nextReihenfolge =
            links.length > 0
                ? Math.max(
                    ...links.map(
                        (link) => Number(link.reihenfolge) || 0
                    )
                ) + 1
                : 1;

        setLinkReihenfolge(
            nextReihenfolge
        );
    }


    // ==================================================
    // BEREICH WECHSELN
    // ==================================================

    function showAppointments() {

        setActiveSection(
            "termine"
        );

        resetNewsForm();

        resetLinkForm();
    }


    function showNews() {

        setActiveSection(
            "news"
        );

        resetAppointmentForm();

        resetLinkForm();
    }


    function showLinks() {

        setActiveSection(
            "links"
        );

        resetAppointmentForm();

        resetNewsForm();
    }


    function showFeedback() {

        setActiveSection(
            "feedback"
        );

        resetAppointmentForm();

        resetNewsForm();

        resetLinkForm();
    }


    // ==================================================
    // ABMELDEN
    // ==================================================

    async function handleLogout() {

        try {

            await fetch(
                `${API_URL}/logout.php`,
                {
                    method:
                        "POST",

                    credentials:
                        "include",

                    headers: {

                        "Content-Type":
                            "application/json"
                    }
                }
            );

        } catch (error) {

            console.error(
                "Fehler beim Abmelden:",
                error
            );

        } finally {

            localStorage.removeItem(
                "token"
            );

            localStorage.removeItem(
                "username"
            );


            setUsername(
                ""
            );

            setIsAuthenticated(
                false
            );


            navigate(
                "/login",
                {
                    replace: true
                }
            );
        }
    }


    // ==================================================
    // ADMINBEREICH ERST NACH SERVERPRÜFUNG ANZEIGEN
    // ==================================================

    if (
        !authChecked ||
        !isAuthenticated
    ) {

        return null;
    }


    // ==================================================
    // AUSGABE
    // ==================================================

    return (
        <>

            <div className="intro">

                <p>
                    Administration
                </p>

            </div>


            <main className="admin-main">

                <section className="admin-bereich">


                    {/* ================================= */}
                    {/* BENUTZER */}
                    {/* ================================= */}

                    <p>
                        Angemeldet als:{" "}

                        <strong>
                            {username}
                        </strong>
                    </p>


                    <button
                        className="admin-logout"
                        type="button"
                        onClick={
                            handleLogout
                        }
                    >
                        Abmelden
                    </button>


                    <hr />


                    {/* ================================= */}
                    {/* ADMIN-NAVIGATION */}
                    {/* ================================= */}

                    <h2>
                        Verwaltung
                    </h2>


                    <div className="admin-navigation">

                        <button
                            type="button"
                            onClick={
                                showAppointments
                            }
                            disabled={
                                activeSection ===
                                "termine"
                            }
                        >
                            Termine verwalten
                        </button>


                        <button
                            type="button"
                            onClick={
                                showNews
                            }
                            disabled={
                                activeSection ===
                                "news"
                            }
                        >
                            News verwalten
                        </button>


                        <button
                            type="button"
                            onClick={
                                showLinks
                            }
                            disabled={
                                activeSection ===
                                "links"
                            }
                        >
                            Links verwalten
                        </button>


                        <button
                            type="button"
                            onClick={
                                showFeedback
                            }
                            disabled={
                                activeSection ===
                                "feedback"
                            }
                        >
                            Feedback verwalten
                        </button>

                    </div>


                    <hr />


                    {/* ================================= */}
                    {/* TERMINVERWALTUNG */}
                    {/* ================================= */}

                    {
                        activeSection ===
                        "termine" && (

                            <>
                                <h1>
                                    Terminverwaltung
                                </h1>


                                <h2>
                                    {
                                        editId === null
                                            ? "Neuen Termin anlegen"
                                            : "Termin bearbeiten"
                                    }
                                </h2>


                                <form
                                    className="admin-formular"
                                    onSubmit={
                                        handleAppointmentSubmit
                                    }
                                >

                                    <p>
                                        <label>
                                            Datum:

                                            <input
                                                type="date"
                                                value={
                                                    datum
                                                }
                                                onChange={
                                                    handleDateChange
                                                }
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Wochentag:

                                            <input
                                                type="text"
                                                value={
                                                    tag
                                                }
                                                readOnly
                                                placeholder="Wird automatisch berechnet"
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Startzeit:

                                            <input
                                                type="time"
                                                value={
                                                    startzeit
                                                }
                                                onChange={
                                                    (event) =>
                                                        setStartzeit(
                                                            event.target.value
                                                        )
                                                }
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Endzeit:

                                            <input
                                                type="time"
                                                value={
                                                    endzeit
                                                }
                                                onChange={
                                                    (event) =>
                                                        setEndzeit(
                                                            event.target.value
                                                        )
                                                }
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Status:

                                            <select
                                                value={
                                                    status
                                                }
                                                onChange={
                                                    (event) =>
                                                        setStatus(
                                                            event.target.value
                                                        )
                                                }
                                            >

                                                <option value="Frei">
                                                    Frei
                                                </option>

                                                <option value="Vergeben">
                                                    Vergeben
                                                </option>

                                            </select>
                                        </label>
                                    </p>


                                    <button
                                        type="submit"
                                    >
                                        {
                                            editId === null
                                                ? "Termin speichern"
                                                : "Änderungen speichern"
                                        }
                                    </button>


                                    {
                                        editId !== null && (

                                            <>
                                                {" "}

                                                <button
                                                    type="button"
                                                    onClick={
                                                        resetAppointmentForm
                                                    }
                                                >
                                                    Abbrechen
                                                </button>
                                            </>
                                        )
                                    }

                                </form>


                                <h2>
                                    Vorhandene Termine
                                </h2>


                                <div className="admin-tabelle-container">

                                    <table className="admin-tabelle">

                                        <thead>

                                            <tr>
                                                <th>
                                                    ID
                                                </th>

                                                <th>
                                                    Datum
                                                </th>

                                                <th>
                                                    Tag
                                                </th>

                                                <th>
                                                    Zeit
                                                </th>

                                                <th>
                                                    Status
                                                </th>

                                                <th>
                                                    Aktionen
                                                </th>
                                            </tr>

                                        </thead>


                                        <tbody>

                                            {
                                                appointments.map(
                                                    (appointment) => (

                                                        <tr
                                                            key={
                                                                appointment.id
                                                            }
                                                        >

                                                            <td>
                                                                {
                                                                    appointment.id
                                                                }
                                                            </td>


                                                            <td>
                                                                {
                                                                    appointment.datum
                                                                }
                                                            </td>


                                                            <td>
                                                                {
                                                                    appointment.tag
                                                                }
                                                            </td>


                                                            <td>
                                                                {
                                                                    appointment.zeit
                                                                }
                                                            </td>


                                                            <td
                                                                className={
                                                                    appointment.status ===
                                                                    "Frei"
                                                                        ? "admin-status-frei"
                                                                        : "admin-status-vergeben"
                                                                }
                                                            >
                                                                {
                                                                    appointment.status
                                                                }
                                                            </td>


                                                            <td>

                                                                <button
                                                                    type="button"
                                                                    onClick={
                                                                        () =>
                                                                            handleAppointmentEdit(
                                                                                appointment
                                                                            )
                                                                    }
                                                                >
                                                                    Ändern
                                                                </button>


                                                                {" "}


                                                                <button
                                                                    type="button"
                                                                    onClick={
                                                                        () =>
                                                                            handleAppointmentDelete(
                                                                                appointment.id
                                                                            )
                                                                    }
                                                                >
                                                                    Löschen
                                                                </button>

                                                            </td>

                                                        </tr>
                                                    )
                                                )
                                            }

                                        </tbody>

                                    </table>

                                </div>

                            </>
                        )
                    }


                    {/* ================================= */}
                    {/* NEWSVERWALTUNG */}
                    {/* ================================= */}

                    {
                        activeSection ===
                        "news" && (

                            <>
                                <h1>
                                    News-Verwaltung
                                </h1>


                                <h2>
                                    {
                                        newsEditId === null
                                            ? "Neuen News-Beitrag anlegen"
                                            : "News-Beitrag bearbeiten"
                                    }
                                </h2>


                                <form
                                    className="admin-formular"
                                    onSubmit={
                                        handleNewsSubmit
                                    }
                                >

                                    <p>
                                        <label>
                                            Datum:

                                            <input
                                                type="date"
                                                value={
                                                    newsDatum
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsDatum(
                                                            event.target.value
                                                        )
                                                }
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Titel:

                                            <input
                                                type="text"
                                                value={
                                                    newsTitel
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsTitel(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="Titel des Beitrags"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Kurztext:

                                            <textarea
                                                value={
                                                    newsKurztext
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsKurztext(
                                                            event.target.value
                                                        )
                                                }
                                                rows="4"
                                                placeholder="Kurzer Text für die News-Übersicht"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Vollständiger Text:

                                            <textarea
                                                value={
                                                    newsText
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsText(
                                                            event.target.value
                                                        )
                                                }
                                                rows="10"
                                                placeholder="Vollständiger News-Beitrag"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Bild-Dateiname:

                                            <input
                                                type="text"
                                                value={
                                                    newsBild
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsBild(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="z. B. neue-termine.png"
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        Das Bild ist optional.

                                        <br />

                                        Das Bild muss sich im Ordner{" "}

                                        <code>
                                            /Fotos/news/
                                        </code>

                                        {" "}befinden.
                                    </p>


                                    {
                                        newsBild && (

                                            <p>
                                                <strong>
                                                    Bildvorschau:
                                                </strong>

                                                <br />

                                                <img
                                                    className="admin-bildvorschau"
                                                    src={
                                                        getNewsImagePath(
                                                            newsBild
                                                        )
                                                    }
                                                    alt="Vorschau"
                                                />
                                            </p>
                                        )
                                    }


                                    <hr />


                                    <h3>
                                        Optionaler Link
                                    </h3>


                                    <p>
                                        <label>
                                            Link-Text:

                                            <input
                                                type="text"
                                                value={
                                                    newsLinkText
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsLinkText(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="z. B. Freie Termine ansehen"
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Link-Ziel:

                                            <input
                                                type="text"
                                                value={
                                                    newsLinkZiel
                                                }
                                                onChange={
                                                    (event) =>
                                                        setNewsLinkZiel(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="z. B. /freiezeiten"
                                            />
                                        </label>
                                    </p>


                                    <button
                                        type="submit"
                                    >
                                        {
                                            newsEditId === null
                                                ? "News speichern"
                                                : "Änderungen speichern"
                                        }
                                    </button>


                                    {" "}


                                    <button
                                        type="button"
                                        onClick={
                                            resetNewsForm
                                        }
                                    >
                                        Abbrechen
                                    </button>

                                </form>


                                <h2>
                                    Vorhandene News
                                </h2>


                                {
                                    news.length === 0

                                        ? (

                                            <p>
                                                Noch keine News vorhanden.
                                            </p>

                                        )

                                        : (

                                            <div className="admin-tabelle-container">

                                                <table className="admin-tabelle">

                                                    <thead>

                                                        <tr>
                                                            <th>
                                                                ID
                                                            </th>

                                                            <th>
                                                                Datum
                                                            </th>

                                                            <th>
                                                                Titel
                                                            </th>

                                                            <th>
                                                                Kurztext
                                                            </th>

                                                            <th>
                                                                Bild
                                                            </th>

                                                            <th>
                                                                Link
                                                            </th>

                                                            <th>
                                                                Aktionen
                                                            </th>
                                                        </tr>

                                                    </thead>


                                                    <tbody>

                                                        {
                                                            news.map(
                                                                (article) => (

                                                                    <tr
                                                                        key={
                                                                            article.id
                                                                        }
                                                                    >

                                                                        <td>
                                                                            {
                                                                                article.id
                                                                            }
                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                article.datum
                                                                            }
                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                article.titel
                                                                            }
                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                article.kurztext
                                                                            }
                                                                        </td>


                                                                        <td>

                                                                            {
                                                                                article.bild

                                                                                    ? (
                                                                                        <>
                                                                                            <img
                                                                                                className="admin-news-bild"
                                                                                                src={
                                                                                                    getNewsImagePath(
                                                                                                        article.bild
                                                                                                    )
                                                                                                }
                                                                                                alt={
                                                                                                    article.titel
                                                                                                }
                                                                                            />

                                                                                            <br />

                                                                                            <small>
                                                                                                {
                                                                                                    article.bild
                                                                                                }
                                                                                            </small>
                                                                                        </>
                                                                                    )

                                                                                    : (
                                                                                        "Kein Bild"
                                                                                    )
                                                                            }

                                                                        </td>


                                                                        <td>

                                                                            {
                                                                                article.link_text &&
                                                                                article.link_ziel

                                                                                    ? (
                                                                                        <>
                                                                                            <strong>
                                                                                                {
                                                                                                    article.link_text
                                                                                                }
                                                                                            </strong>

                                                                                            <br />

                                                                                            <code>
                                                                                                {
                                                                                                    article.link_ziel
                                                                                                }
                                                                                            </code>
                                                                                        </>
                                                                                    )

                                                                                    : (
                                                                                        "Kein Link"
                                                                                    )
                                                                            }

                                                                        </td>


                                                                        <td>

                                                                            <button
                                                                                type="button"
                                                                                onClick={
                                                                                    () =>
                                                                                        handleNewsEdit(
                                                                                            article
                                                                                        )
                                                                                }
                                                                            >
                                                                                Ändern
                                                                            </button>


                                                                            {" "}


                                                                            <button
                                                                                type="button"
                                                                                onClick={
                                                                                    () =>
                                                                                        handleNewsDelete(
                                                                                            article.id
                                                                                        )
                                                                                }
                                                                            >
                                                                                Löschen
                                                                            </button>

                                                                        </td>

                                                                    </tr>
                                                                )
                                                            )
                                                        }

                                                    </tbody>

                                                </table>

                                            </div>
                                        )
                                }

                            </>
                        )
                    }


                    {/* ================================= */}
                    {/* LINKVERWALTUNG */}
                    {/* ================================= */}

                    {
                        activeSection ===
                        "links" && (

                            <>
                                <h1>
                                    Link-Verwaltung
                                </h1>


                                <h2>
                                    {
                                        linkEditId === null
                                            ? "Neuen Link anlegen"
                                            : "Link bearbeiten"
                                    }
                                </h2>


                                <form
                                    className="admin-formular"
                                    onSubmit={
                                        handleLinkSubmit
                                    }
                                >

                                    <p>
                                        <label>
                                            Reihenfolge:

                                            <input
                                                type="number"
                                                min="1"
                                                value={
                                                    linkReihenfolge
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkReihenfolge(
                                                            event.target.value
                                                        )
                                                }
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Name:

                                            <input
                                                type="text"
                                                value={
                                                    linkName
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkName(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="z. B. Body-Heart-Soul"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Beschreibung:

                                            <textarea
                                                value={
                                                    linkBeschreibung
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkBeschreibung(
                                                            event.target.value
                                                        )
                                                }
                                                rows="4"
                                                placeholder="Beschreibung des Angebots"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Bild-Dateiname:

                                            <input
                                                type="text"
                                                value={
                                                    linkBild
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkBild(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="z. B. body-heart-soul.png"
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        Das Bild ist optional.

                                        <br />

                                        Es muss sich im Ordner{" "}

                                        <code>
                                            /Fotos/
                                        </code>

                                        {" "}befinden.

                                        <br />

                                        Du gibst nur den Dateinamen ein.
                                    </p>


                                    {
                                        linkBild && (

                                            <p>
                                                <strong>
                                                    Bildvorschau:
                                                </strong>

                                                <br />

                                                <img
                                                    className="admin-bildvorschau"
                                                    src={
                                                        getLinkImagePath(
                                                            linkBild
                                                        )
                                                    }
                                                    alt="Vorschau"
                                                />
                                            </p>
                                        )
                                    }


                                    <p>
                                        <label>
                                            Webseite / URL:

                                            <input
                                                type="url"
                                                value={
                                                    linkUrl
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkUrl(
                                                            event.target.value
                                                        )
                                                }
                                                placeholder="https://www.beispiel.ch/"
                                                required
                                            />
                                        </label>
                                    </p>


                                    <p>
                                        <label>
                                            Anzeigen:

                                            <select
                                                value={
                                                    linkAktiv
                                                        ? "1"
                                                        : "0"
                                                }
                                                onChange={
                                                    (event) =>
                                                        setLinkAktiv(
                                                            event.target.value ===
                                                            "1"
                                                        )
                                                }
                                            >

                                                <option value="1">
                                                    Ja
                                                </option>

                                                <option value="0">
                                                    Nein
                                                </option>

                                            </select>
                                        </label>
                                    </p>


                                    <p>
                                        Bei{" "}

                                        <strong>
                                            Nein
                                        </strong>

                                        {" "}bleibt der Link gespeichert,
                                        wird aber auf der öffentlichen
                                        Links-Seite nicht angezeigt.
                                    </p>


                                    <button
                                        type="submit"
                                    >
                                        {
                                            linkEditId === null
                                                ? "Link speichern"
                                                : "Änderungen speichern"
                                        }
                                    </button>


                                    {" "}


                                    <button
                                        type="button"
                                        onClick={
                                            resetLinkForm
                                        }
                                    >
                                        Abbrechen
                                    </button>

                                </form>


                                <h2>
                                    Vorhandene Links
                                </h2>


                                {
                                    links.length === 0

                                        ? (

                                            <p>
                                                Noch keine Links vorhanden.
                                            </p>

                                        )

                                        : (

                                            <div className="admin-tabelle-container">

                                                <table className="admin-tabelle">

                                                    <thead>

                                                        <tr>
                                                            <th>
                                                                ID
                                                            </th>

                                                            <th>
                                                                Reihenfolge
                                                            </th>

                                                            <th>
                                                                Bild
                                                            </th>

                                                            <th>
                                                                Name
                                                            </th>

                                                            <th>
                                                                Beschreibung
                                                            </th>

                                                            <th>
                                                                URL
                                                            </th>

                                                            <th>
                                                                Anzeigen
                                                            </th>

                                                            <th>
                                                                Aktionen
                                                            </th>
                                                        </tr>

                                                    </thead>


                                                    <tbody>

                                                        {
                                                            links.map(
                                                                (link) => (

                                                                    <tr
                                                                        key={
                                                                            link.id
                                                                        }
                                                                    >

                                                                        <td>
                                                                            {
                                                                                link.id
                                                                            }
                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                link.reihenfolge
                                                                            }
                                                                        </td>


                                                                        <td>

                                                                            {
                                                                                link.bild

                                                                                    ? (

                                                                                        <>
                                                                                            <img
                                                                                                className="admin-news-bild"
                                                                                                src={
                                                                                                    getLinkImagePath(
                                                                                                        link.bild
                                                                                                    )
                                                                                                }
                                                                                                alt={
                                                                                                    link.name
                                                                                                }
                                                                                            />

                                                                                            <br />

                                                                                            <small>
                                                                                                {
                                                                                                    link.bild
                                                                                                }
                                                                                            </small>
                                                                                        </>

                                                                                    )

                                                                                    : (
                                                                                        "Kein Bild"
                                                                                    )
                                                                            }

                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                link.name
                                                                            }
                                                                        </td>


                                                                        <td>
                                                                            {
                                                                                link.beschreibung
                                                                            }
                                                                        </td>


                                                                        <td>

                                                                            <a
                                                                                href={
                                                                                    link.url
                                                                                }
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {
                                                                                    link.url
                                                                                }
                                                                            </a>

                                                                        </td>


                                                                        <td>

                                                                            {
                                                                                Number(
                                                                                    link.aktiv
                                                                                ) === 1
                                                                                    ? "Ja"
                                                                                    : "Nein"
                                                                            }

                                                                        </td>


                                                                        <td>

                                                                            <button
                                                                                type="button"
                                                                                onClick={
                                                                                    () =>
                                                                                        handleLinkEdit(
                                                                                            link
                                                                                        )
                                                                                }
                                                                            >
                                                                                Ändern
                                                                            </button>


                                                                            {" "}


                                                                            <button
                                                                                type="button"
                                                                                onClick={
                                                                                    () =>
                                                                                        handleLinkDelete(
                                                                                            link.id
                                                                                        )
                                                                                }
                                                                            >
                                                                                Löschen
                                                                            </button>

                                                                        </td>

                                                                    </tr>
                                                                )
                                                            )
                                                        }

                                                    </tbody>

                                                </table>

                                            </div>
                                        )
                                }

                            </>
                        )
                    }


                    {/* ================================= */}
                    {/* FEEDBACKVERWALTUNG */}
                    {/* ================================= */}

                    {
                        activeSection ===
                        "feedback" && (

                            <AdminFeedback
                                token={
                                    token
                                }
                                checkResponse={
                                    checkResponse
                                }
                            />
                        )
                    }

                </section>

            </main>

        </>
    );
}


export default AdminPage;